var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatDocBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 52.9286,
    height: 52.9286,
    viewBox: "0 0 52.9286 52.9286",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 90"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.9286,
    height: 52.9286,
    rx: 26.4643,
    fill: "#0C45CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M38.3394 17.0302C39.1343 16.2353 40.4233 16.2355 41.2183 17.0302C42.0133 17.8252 42.0133 19.1141 41.2183 19.9091L24.3121 36.8144C24.2232 36.9719 24.1141 37.1217 23.98 37.2558C23.185 38.0506 21.8961 38.0507 21.1011 37.2558L11.7105 27.8642C10.9155 27.0692 10.9155 25.7803 11.7105 24.9853C12.5055 24.1906 13.7945 24.1904 14.5894 24.9853L22.4859 32.8828L38.3394 17.0302Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatDocBadge);
export default __webpack_public_path__ + "static/media/feat_doc_badge.2b2209750dcc5561ef1ea167e780a9eb.svg";
export { ForwardRef as ReactComponent };